module.exports = __webpack_public_path__ + "static/NataliePool-d794a6fe2d2a3b267e1c448b95315a56.jpeg";